<template>
    <div>
        <router-link tag="a" class="back-button right mb11" to="/portfolio">Back to portfolio</router-link>
        <h6 class="headline-sm">K-12 SCHOOLS</h6>
        <ul class="portfolio-list">
            <li>
                <img img src="images/Our-Work-Page/K-12-Schools/k-12-1.png" alt="">
                <strong class="portfolio-list-name">Fruitland High School Baseball Wall</strong>
                <span class="portfolio-list-location">Fruitland, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/K-12-Schools/k-12-2.png" alt="">
                <strong class="portfolio-list-name">McCall-Donnelly Joint School District</strong>
                <span class="portfolio-list-location">McCall, ID</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/K-12-Schools/k-12-3.png" alt="">
                <strong class="portfolio-list-name">Cleveland Elementary School</strong>
                <span class="portfolio-list-location">Norman, OK</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/K-12-Schools/k-12-4.png" alt="">
                <strong class="portfolio-list-name">Purnell Swett High School</strong>
                <span class="portfolio-list-location">Pembroke, NC</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/K-12-Schools/k-12-5.png" alt="">
                <strong class="portfolio-list-name">Del Mar Pines School</strong>
                <span class="portfolio-list-location">San Diego, CA</span>
            </li>
            <li>
                <img img src="images/Our-Work-Page/K-12-Schools/k-12-6.png" alt="">
                <strong class="portfolio-list-name">St. Mark’s High School</strong>
                <span class="portfolio-list-location">Wilmington, DE</span>
            </li>
        </ul>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'k12',
        metaInfo: {
            title: 'K-12 Schools'
        }
    }
</script>



// WEBPACK FOOTER //
// k-12.vue?03dd8c19